import { render, staticRenderFns } from "./menuModifiers.vue?vue&type=template&id=1bacf627&scoped=true&"
import script from "./menuModifiers.vue?vue&type=script&lang=js&"
export * from "./menuModifiers.vue?vue&type=script&lang=js&"
import style0 from "./menuModifiers.vue?vue&type=style&index=0&id=1bacf627&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bacf627",
  null
  
)

export default component.exports